import { render } from "./Watermark.vue?vue&type=template&id=6ecc494e&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"

import "./Watermark.vue?vue&type=style&index=0&id=6ecc494e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecc494e"]])

export default __exports__